/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  downloadLink?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'origami butterfly',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqC',
    textDescription:
      'Origami, the art of paper folding, is a fun and simple way to get little ones to follow directions, get crafty and create a little piece of art only using paper! There are no other supplies necessary to make this origami butterfly, just print out the two sheets, follow the step-by-step guide and give it a try!',
    downloadLink:
      'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/binary/MD1UrC',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <a href={this.printPage.downloadLink}  className='print-download-link' target='_blank'>download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
